import React, { useEffect, useState } from "react";
import DynamicBanner from "../../Pages/include/DynamicBanner";
import DynamicFacilities from "../../Pages/Others/Maintainence/Partials/DynamicFacilities";
import api from "../../../api";

const removeBaseUrl = (url) => {
  if (!url || typeof url !== "string") return url;

  const baseUrls = [
    process.env.REACT_APP_API_URL + "/public",
    process.env.REACT_APP_API_URL,
    "/public",
  ];

  let clean = url;
  baseUrls.forEach((base) => {
    if (clean.startsWith(base)) {
      clean = clean.replace(base, "");
    }
  });

  return clean.startsWith("/") ? clean : "/" + clean;
};

const formatImagePaths = (data) => {
  const formattedData = { ...data };
  if (formattedData.banner?.images) {
    formattedData.banner.images = formattedData.banner.images.map((img) => removeBaseUrl(img));
  }
  if (formattedData.content?.facilities) {
    formattedData.content.facilities = formattedData.content.facilities.map((item) => ({
      ...item,
      image: removeBaseUrl(item.image),
    }));
  }
  return formattedData;
};

const CampusFacilities = () => {
  const [banner, setBanner] = useState({
    title: "",
    images: [],
    mobile_images: []
  });

  const [mainHeading, setMainHeading] = useState("");
  const [facilityCards, setFacilityCards] = useState([]);

  useEffect(() => {
    let cancel = false;

    const fetchData = async () => {
      try {
        const res = await api.get("/api/sitepages/academic/campus-life");
        const fullData = res.data?.data || [];
        const pageData = fullData.find((item) => item.page_slug === "common-facilities");

        if (!pageData) return;

        const cleanedData = formatImagePaths(pageData);
        setBanner({
          title: cleanedData.banner?.title || "",
          images: cleanedData.banner?.images || [],
          mobile_images: cleanedData.banner?.mobile_images || []
        });

        setMainHeading(cleanedData.content?.main_heading || "");

        const formattedCards = (cleanedData.content?.facilities || []).map((f) => ({
          title: f.heading || "",
          text: f.description || "",
          read_more_content: f.read_more_content || "", // Raw HTML string
          read_more_text: f.read_more_text || "Read More",
          read_less_text: "Read Less",
          image: f.image || "",
          alt: f.heading || "",
        }));

        if (!cancel) setFacilityCards(formattedCards);
      } catch (error) {
        console.error("Error loading common facilities data:", error);
      }
    };

    fetchData();
    return () => (cancel = true);
  }, []);

  return (
    <>
      <DynamicBanner
        title={banner.title}
        bgImage={banner.images}
        bgImageMobile={banner.mobile_images}
      />

      <section className="content-section-maintainence mt-0 mt-md-3">
        <div className="container">
          <DynamicFacilities heading={mainHeading} cards={facilityCards} />
        </div>
      </section>
    </>
  );
};

export default CampusFacilities;